const menu_data = [
  {
    id: 1,
    hasDropdown: false,
    title: 'Home',
    link: '/',
  },
  {
    id: 2,
    title: 'About',
    link: '/about',
  },
  {
    id: 3,
    hasDropdown: true,
    title: 'Services',
    link: '/service',
    submenus: [
      { title: 'Corparartive Vas', link: '/team' },
      { title: 'Mobile Vas', link: '/team-details' },
      { title: 'Production', link: '/service' },
    ]
  },
  {
    id: 4,
    hasDropdown: true,
    title: 'Media',
    link: '/blog',
    submenus: [
      { title: 'news', link: '/blog' },
      { title: 'gallery', link: '/blog-details' },
      { title: 'Faq', link: '/faq' },
    ]
  },
  {
    id: 5,
    hasDropdown: false,
    title: 'Contact',
    link: '/contact',
  },
]

export default menu_data;
